var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{style:((_vm.show ? '' : 'display: none;')),attrs:{"icon":"mdi-format-list-checkbox","title":"Action Items","wide":_vm.wide}},[_c('ActionItems',{attrs:{"module":{actionItemsId: _vm.type + ':' + _vm.id}},on:{"show":function($event){_vm.show = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }